import React, {useRef} from 'react';
import {observer} from 'mobx-react-lite';
import {ClipTypeEnum, Engine} from "@rendley/sdk";
import {TRACK_CLASSNAME} from "../../config/constants";
import {ApplicationStore} from "../../../../store/ApplicationStore";
import {convertUnitsToTime} from "../../../../utils/dom/convertUnitsToTime";
import './Track.styles.scss';

// Import your clip components here
// import Transition from "../Transition/Transition";
import {CompositionStateStore, UserClip} from "../../../../store/CompositionStateStore";
import VideoClip from "../VideoClip/VideoClip";

interface TrackProps {
    layerId: string;
    setContextMenuVisible: (visible: boolean) => void;
    setContextMenuPosition: (position: { x: number, y: number }) => void;
    timelineTracksRef: React.RefObject<HTMLDivElement>;
}

export const Track: React.FC<TrackProps> = observer(({ layerId }) => {
    const placeholderRef = useRef<HTMLDivElement>(null);
    // const createDropClipPlaceholder = useCreateDropClipPlaceholder(() => placeholderRef.current);

    const layer = CompositionStateStore.layers[layerId];
    // const temporaryTransitions = layer ? TimelineService.getTemporaryTransitions(layerId) : [];
    const clipsIds =  layer.clipIds;
    const transitionIds = [];
    const clips = clipsIds.reduce<Record<string, UserClip>>((acc, cv) => {
        acc[cv] = CompositionStateStore.clips[cv];
        return acc;
    }, {});

    const isScriptLayer = true;
    let layerHasWideClip = false;
    for (const [id, clip] of Object.entries(clips) as [string, UserClip][]) {
        if (clip.type === ClipTypeEnum.AUDIO || clip.type === ClipTypeEnum.VIDEO) {
            layerHasWideClip = true;
        }
    }

    const trackHeight = isScriptLayer ? "5.25rem" : layerHasWideClip ? "4.25rem" : "2.25rem";

    const handleDrop = async (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();

        // @ts-ignore
        // createDropClipPlaceholder.onDragLeave(event);
        let librettoClipId = null;
        try {
            const draggingObject = ApplicationStore.draggingObject;
            let clipId: string | undefined;

            if (!draggingObject) {
                return null;
            }

            if (draggingObject.type === "media") {
                // const mediaId = draggingObject.payload.id;
                // const startTime = convertUnitsToTime(event.nativeEvent.offsetX);
                // const clip = await RendleyService.addMediaToLayer(layerId, mediaId, startTime);
                // librettoClipId = clip.getCustomData(CLIP_LIBRETTO_CLIP_ID) as string;
                // if (librettoClipId === null || librettoClipId === "" || librettoClipId === undefined) {
                //     librettoClipId = GenerateLibrettoClipId();
                //     clip.setCustomData(CLIP_LIBRETTO_CLIP_ID, librettoClipId);
                //     RendleyStore.addClipIdForLibrettoClip(librettoClipId, clip.id);
                //     RendleyStore.setLayerIdForLibrettoClip(librettoClipId, layer.id);
                //     RendleyStore.addLibrettoClipIdToLayer(librettoClipId, layer.id);
                // }
                // clipId = clip?.id;
            }

            if (draggingObject.type === "text-preset") {
                // const title = draggingObject.payload;
                // const startTime = convertUnitsToTime(event.nativeEvent.offsetX);
                // const clip = await RendleyService.createLottieClip({
                //     dataUrl: title.dataUrl,
                //     propertiesUrl: title.propertiesUrl,
                //     startTime,
                //     layerId: layerId,
                // });
                // librettoClipId = clip.getCustomData(CLIP_LIBRETTO_CLIP_ID) as string;
                // if (librettoClipId === null || librettoClipId === "" || librettoClipId === undefined) {
                //     librettoClipId = GenerateLibrettoClipId();
                //     clip.setCustomData(CLIP_LIBRETTO_CLIP_ID, librettoClipId);
                //     RendleyStore.addClipIdForLibrettoClip(librettoClipId, clip.id);
                //     RendleyStore.setLayerIdForLibrettoClip(librettoClipId, layer.id);
                //     RendleyStore.addLibrettoClipIdToLayer(librettoClipId, layer.id);
                // }
                // clipId = clip?.id;
            }

            if (clipId != null) {
                ApplicationStore.setSelectedLibrettoClipId(librettoClipId);
            }
        } catch {
            return null;
        }
    };

    const ReadableClipType = (clipType: string) => {
        return String(clipType).toLowerCase();
    }


    const renderClip = (clipId: string, index: number) => {
        const clip = clips[clipId];

        console.log("Rendering clip with clip id: ", clipId, " and clip type ", clip.type);

        switch (ReadableClipType(clip.type)) {
            case ClipTypeEnum.GIF:
            case ClipTypeEnum.VIDEO:
                return <VideoClip clipId={clip.id} layerId={layerId} />;
            default:
                return null;
        }
    };


    // const renderTransition = (transitionId: string) => {
    //     return <Transition key={transitionId} type="permanent" permanentTransition={{ transitionId }} />;
    // };
    //
    // const renderTransitionPlaceholder = ({ startTime, layerId, clipId }: any) => {
    //     return <Transition key={startTime} type="temporary" temporaryTransition={{ startTime, layerId, clipId }} />;
    // };

    const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        // @ts-ignore
        return createDropClipPlaceholder.onDragEnter(event);
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        // @ts-ignore
        return createDropClipPlaceholder.onDragOver(event);
    };

    const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        // @ts-ignore
        return createDropClipPlaceholder.onDragLeave(event);
    };

    return (
        <div id={layerId} className={`${TRACK_CLASSNAME} ${TRACK_CLASSNAME}-${layerId}`}>
            <div
                className="track__content"
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                style={{ height: trackHeight}}
                onDrop={handleDrop}
                onDragLeave={handleDragLeave}
            >
                <div ref={placeholderRef} className="track__drop-clip-placeholder"></div>
                {clipsIds.map(renderClip)}
                {/*{transitionIds.map(renderTransition)}*/}
                {/*{temporaryTransitions.map(renderTransitionPlaceholder)}*/}
            </div>
        </div>
    );
});